module.exports = __webpack_public_path__ + "img/egud.d73d3c00.jpg";